<template>
  <div>
    <loader :show="showLoader" class="mb20" :center="false"></loader>
    <p v-if="showLoader">{{ $t("authing") }}</p>
  </div>
</template>
<script>
import api from "../../api/index.js";
import { mapGetters } from "vuex";
import { renderProviderLink } from "../../utils/utils.js";
export default {
  data() {
    return {
      data: "",
      err: "",
      showLoader: true
    };
  },
  computed: {
    ...mapGetters(["lang"])
  },
  mounted() {
    const code = this.$route.query.code;
    const provider = this.$route.params.provider;
    if (provider == "google") {
      api
        .googleOauth({
          code: code,
          lang: this.lang,
          provider: provider
        })
        .then(response => {
          this.$store.dispatch("doLogin", {
            token: response.data.token,
            userInfo: response.data.userInfo
          });
          setTimeout(() => {
            this.$router.push(
              response.data.userInfo.username
                ? "/index"
                : "/profile/firstSetting"
            );
          }, 2000);
        })
        .catch(err => {
          // window.location.href = renderProviderLink(provider);
          this.$UiToast({
            position: {
              x: "center",
              y: "top"
            },
            message: this.$t("googleLoginFailed"),
            onClose: () => {
              this.$router.push("/index");
            },
            type: "error"
          });
        });
    }
  }
};
</script>
